import React from 'react';
import linkedin from '../../../images/linkedin.jpg';
import github from '../../../images/github.png';
import fb from '../../../images/fb.png';
import twitter from '../../../images/twitter.png';

const Footer = () => {
    return (
        <div className="text-center mt-5 text-white">
            <small>2021 || &reg; Rajon Ahmed</small> |
            <a className="textColor text-decoration-none" href="https://www.linkedin.com/in/rajon749/" target="_blank" rel="noreferrer"> <img src={linkedin} className="socialMediaFooter" alt="linkedin"/>                    
            </a>                                
            <a className="textColor text-decoration-none" href="https://github.com/rajonahmed749" target="_blank" rel="noreferrer"> <img src={github} className="socialMediaFooter" alt="github"/>                    
            </a>   
            <a className="textColor text-decoration-none" href="https://twitter.com/Rajon749" target="_blank" rel="noreferrer"> <img src={twitter} className="socialMediaFooter" alt="github"/>                    
            </a>   
            <a className="textColor text-decoration-none" href="https://www.facebook.com/razon.hossain.338/" target="_blank" rel="noreferrer"> <img src={fb} className="socialMediaFooter" alt="fb"/>                    
            </a>            
        </div>
    );
};

export default Footer;